// extracted by mini-css-extract-plugin
export default {"dots":"_2c8H","dot1":"_2P6O","load":"_2bqo","dot2":"_10HF","dot3":"_3HoM"};